//
// Site Clock functions
//
export default class SiteClock {
  constructor() {

    this.siteClocks = document.querySelectorAll('.js-site-clock');

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
  setClock(siteClock) {

    let minsHand = siteClock.querySelector('.js-site-clock__minute');
    let hourHand = siteClock.querySelector('.js-site-clock__hour');

    let clockTimeZone = '';

    // If the clock is the New York
    if (siteClock.id == 'js-site-clock--ny') {
      clockTimeZone = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}));
    // Otherwise default to London
    } else {
      clockTimeZone = new Date(new Date().toLocaleString("en-US", {timeZone: "Europe/London"}));
    }

    let seconds = clockTimeZone.getSeconds();

    let mins = clockTimeZone.getMinutes();
    let minsDegrees = ((mins / 60) * 360) + ((seconds/60)*6) + 90;
    minsHand.style.transform = `rotate(${minsDegrees}deg)`;

    let hour = clockTimeZone.getHours();
    let hourDegrees = ((hour / 12) * 360) + ((mins/60)*30) + 90;
    hourHand.style.transform = `rotate(${hourDegrees}deg)`;
  }

  addEventHandling() {
    this.siteClocks.forEach(siteClock => {
      setInterval(this.setClock(siteClock), 60 * 1000);
    });

  }
}